module.exports = __webpack_public_path__ + "assets/img/cono.7942dc90.png";